import { ADMIN_API_URL } from './apiConfig';
import { getStoredToken } from './authApi';

const AUTH_PREFIX = `${ADMIN_API_URL}/api/v1/auth`;

async function request(path, options = {}) {
  const token = getStoredToken();
  const res = await fetch(`${AUTH_PREFIX}${path}`, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...(options.headers ?? {}),
    },
  });

  const json = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error(json?.error ?? json?.message ?? `Request failed: ${res.status}`);
  }
  return json?.data ?? json;
}

export function listUsers() {
  return request('/users');
}

export function createUser(user) {
  return request('/users', {
    method: 'POST',
    body: JSON.stringify(user),
  });
}

export function updateUser(userId, user) {
  return request(`/users/${userId}`, {
    method: 'PUT',
    body: JSON.stringify(user),
  });
}

export function deleteUser(userId) {
  return request(`/users/${userId}`, {
    method: 'DELETE',
  });
}

export function listUserTypes() {
  return request('/user-types');
}

export function listMenus() {
  return request('/menus');
}

export function createMenu(menu) {
  return request('/menus', {
    method: 'POST',
    body: JSON.stringify(menu),
  });
}

export function updateMenu(menuId, menu) {
  return request(`/menus/${menuId}`, {
    method: 'PUT',
    body: JSON.stringify(menu),
  });
}

export function deleteMenu(menuId) {
  return request(`/menus/${menuId}`, {
    method: 'DELETE',
  });
}

export function listMenuPermissions() {
  return request('/menu-permissions');
}

export function getRoleMenuPermissions(userTypeId) {
  return request(`/user-types/${userTypeId}/menu-permissions`);
}

export function saveRoleMenuPermissions(userTypeId, permissions) {
  return request(`/user-types/${userTypeId}/menu-permissions`, {
    method: 'PUT',
    body: JSON.stringify({ permissions }),
  });
}

export function getUserMenuPermissions(userId) {
  return request(`/users/${userId}/menu-permissions`);
}

export function saveUserMenuPermissions(userId, permissions) {
  return request(`/users/${userId}/menu-permissions`, {
    method: 'PUT',
    body: JSON.stringify({ permissions }),
  });
}
